import React from "react";
import { Button } from "@mui/material";
// import loginLoggo from "../../../MobileScreens/assets/images/loginLoggo.svg";

// import CorporateFareIcon from "@mui/icons-material/CorporateFare";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
// import LockOpenIcon from "@mui/icons-material/LockOpen";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import corTop from "../../../MobileScreens/assets/images/corTop.png";
// import corBot from "../../../MobileScreens/assets/images/corBot.png";
import { useNavigate } from "react-router-dom";
import MobileHeader from "../MobileComponents/MobileHeader";
import MobileBottomNav from "../MobileComponents/MobileBottomNav";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import homeDeliv from "../../../MobileScreens/assets/images/homeDelivery2.svg";
import AvatarPic from "../../../MobileScreens/assets/images/avtarPic.png";
import ListIcon from "@mui/icons-material/List";
import bannertoplayer3 from "../../../MobileScreens/assets/images/bannertoplayer3.svg";
import ChatIcon from "@mui/icons-material/Chat";
import AddIcon from "@mui/icons-material/Add";
import FavoriteIcon from "@mui/icons-material/Favorite";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import DescriptionIcon from "@mui/icons-material/Description";
import Marquee from 'react-fast-marquee';

function MobileDashboard() {
  const navigate = useNavigate();

  return (
    <>
      <MobileHeader />
      <div className="wraperMobile">
        <div className="sectionMobile">
          <div className="maintenDueMain">
            <div>
              <h1 className="maintenDueAmt">
                <CurrencyRupeeIcon /> 4982/-
              </h1>
              <p className="maintenDueMonth">Maintenance Due to January</p>
            </div>

            <h2 className="maintenDueViewAl" onClick={() => navigate('/Invoice')}>
              View All <KeyboardArrowRightIcon />
            </h2>
          </div>
        </div>

        <div className="sectionMobile">
          <div className="onlineFoodMain">
            {/* <marquee
              behavior="scroll"
              direction="right"
              scrollamount="6"
              className="merqu"
            >
              {" "}
              <img src={homeDeliv} className="homeDelivMob" alt='altimg'/>
            </marquee> */}
            <Marquee
              speed={50}
              pauseOnHover
              gradient={false}
              aria-label="Announcement"
            >
              {" "}
              <img src={homeDeliv} className="homeDelivMob" alt='altimg' />
            </Marquee>
            <h2>Online Food Availabel!</h2>
            <Button>Order Now</Button>
            {/* <marquee
              behavior="scroll"
              className="builddingDeli"
              direction="left"
              scrollamount="6"
            >
              <img src={bannertoplayer3} alt='altimg'/>
            </marquee> */}
            <Marquee
              speed={50}
              pauseOnHover
              gradient={false}
              aria-label="Announcement"
            >
           
              <img src={bannertoplayer3} alt='altimg' />
            </Marquee>
          </div>
        </div>

        <div className="sectionMobile" onClick={() => navigate('/NoticeBoard')}>
          <div className="noticMobMain">
            <h1 className="mobContMainHeading">Notice Board</h1>
            <div className="mobNoticDetai">
              <div className="mobNoticDetaiProp">
                {/* <img src={AvatarPic} /> */}
                <ListIcon />
              </div>
              <div className="mobNoticDetaiTimDat">
                <h2>Demo</h2>
                <span>20-01-2024 15:47</span>
              </div>
            </div>
          </div>
        </div>

        <div className="sectionMobile">
          <div className="mobDisctionForm">
            <div className="mobDisctionFormTo">
              <div className="mobDisctionFormToProOut">
                <div className="mobDisctionFormToPro">
                  <ChatIcon />
                </div>
                <h1>Discussion Forum</h1>
              </div>
              <div onClick={() => navigate('/MobileDiscussionForum')}>
                <div className="maintenDueViewAl">
                  <em className="viewAlPlus">
                    <AddIcon />
                  </em>
                  View All
                </div>
              </div>
            </div>

            <div className="mobDiscusinCont">
              <div className="mobDiscusinConTop">
                <div className="mobDiscusinConTopPropOt">
                  <div className="mobDiscusinConTopProp">
                    <img src={AvatarPic} alt='altimg' />
                  </div>
                  <div>
                    <h1>Namrata Patil</h1>
                    <span>9933789836</span>
                  </div>
                </div>
                <div className="mobDiscuDt">20-01-2024 15:47</div>
              </div>
              <div className="MobDisForumTx">
                Lorem ipsm dolor sumit txt. Lorem ipsm dolor sumit txt.
              </div>
              <div className="mobDiscsFormLikComt">
                <span>
                  <FavoriteIcon /> Like
                </span>
                <span>
                  <MarkUnreadChatAltIcon /> Comment
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="sectionMobile">
          <div className="mobUpcomingEventMain">
            <div className="upComingEvTop">
              <h1 className="mobContMainHeading">Upcoming Events</h1>
              <div className="addWithFileIco" onClick={() => navigate('/UpcomingEvents')}>
                <DescriptionIcon />
                <em className="viewAlPlus">
                  <AddIcon />
                </em>
              </div>
            </div>

            <div className="mobDiscusinCont mobUpComCont">
              <div className="mobDiscusinConTop">
                <div className="mobDiscusinConTopPropOt">
                  <div className="mobDiscusinConTopProp">
                    <b>17</b>
                    <em>June</em>
                  </div>
                  <div>
                    <h1>Event Heading Here</h1>
                    <span>Venue - rtg (17-07-2024 10:00)</span>
                  </div>
                </div>
              </div>
              <div className="mobDiscsFormLikComt">
                <span>
                  Created by <b>Snehal Amodkar</b>
                </span>
                <div className="mobDiscuDt">20-01-2024 15:47</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MobileBottomNav />
    </>
  );
}

export default MobileDashboard;
